import { MechanicalAspectService } from './mechanical-aspect.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { MECHANICAL_ASPECT_TYPE, MechanicalAspect } from 'assets-model';
import { Observable } from 'rxjs';



@Injectable({ providedIn: 'root' })
export abstract class MechanicalAspectResolverBase implements Resolve<MechanicalAspect> {

  constructor(protected service: MechanicalAspectService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<MechanicalAspect> {
    const key: number = MECHANICAL_ASPECT_TYPE.entityDecorator.toKeyObjectFromRouteParams(route.params);
    return this.service.get(key);
  }
}



